export default __webpack_public_path__ + "static/media/404-broken-wire.122ae23a.svg";